import React from 'react';
import { NextPage } from 'next';
import Head from 'next/head';
import { useIntl } from 'react-intl';
import { nextAsset } from '../../../../components/nextAsset';
import { SmartlinksLinkfireAlternativePageTop } from './SmartlinksLinkfireAlternativePageTop';
import { Footer } from '../../../../layouts/Footer';
import { SmartlinksLinkfireAlternativeWhyBest } from './SmartlinksLinkfireAlternativeWhyBest';
import { SmartlinksLinkfireAlternativeBenefits } from './SmartlinksLinkfireAlternativeBenefits';
import { SmartlinksLinkfireAlternativeExplore } from './SmartlinksLinkfireAlternativeExplore';
import { SmartlinksLinkfireAlternativeHowItWorks } from './SmartlinksLinkfireAlternativeHowItWorks';
import { SmartlinksLinkfireAlternativeBuiltFor } from './SmartlinksLinkfireAlternativeBuiltFor';
import { SmartlinksLinkfireAlternativeWhyChose } from './SmartlinksLinkfireAlternativeWhyChose';
import { BigCTA } from '../BigCTA';

/* eslint-disable react/no-danger */
export const LinkfireAlternativePage: NextPage = React.memo(() => {
  const intl = useIntl();
  const title = intl.formatMessage({
    id: 'sml.web.smart-links.linkfire_alternative.title',
    defaultMessage: 'What makes Music24 a great Linkfire alternative'
  });
  const description = intl.formatMessage({
    id: 'sml.web.smart-links.linkfire_alternative.description',
    defaultMessage:
      'Looking for the best Linkfire alternative? Music24 is a modern platform for connecting fans to your music in a simple and smart way 🎧'
  });
  const promoImage = nextAsset(`images/smartLinks/alternative/preview.png`, false, { w: 1200 });
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta property="twitter:title" content={title} key="twitter-title" />
        <meta property="og:title" content={title} key="fb-title" />
        <meta itemProp="description" content={description} key="itemProp-description" />
        <meta name="description" content={description} key="description" />
        <meta property="og:description" content={description} key="fb-description" />
        <meta property="twitter:description" content={description} key="twitter-description" />
        <meta itemProp="image" content={promoImage} key="image" />
        <meta property="twitter:image" content={promoImage} key="twitter-image" />
        <meta property="twitter:image:width" content="1200" key="twitter-image-width" />
        <meta property="twitter:image:height" content="600" key="twitter-image-height" />
        <meta property="og:image" content={promoImage} key="fb-image" />
      </Head>
      <SmartlinksLinkfireAlternativePageTop />
      <SmartlinksLinkfireAlternativeWhyBest />
      <SmartlinksLinkfireAlternativeBenefits />
      <SmartlinksLinkfireAlternativeExplore />
      <SmartlinksLinkfireAlternativeHowItWorks />
      <SmartlinksLinkfireAlternativeBuiltFor />
      <SmartlinksLinkfireAlternativeWhyChose />
      <div className="bg-primary-dark">
        <BigCTA roundedTop source="LinkFireAlternative Bottom CTA" />
      </div>
      <Footer />
    </>
  );
});
